import { useTranslation } from 'react-i18next';
import { Warning } from '@phosphor-icons/react';

// DevModeBanner is the "this is not production" notice rendered above every
// route. Pre-launch the DB is wiped + replayed on schema changes (see the
// pre-launch DB workflow in CLAUDE.md), so anyone trying out the app should
// know their data isn't durable yet. Remove this component at production
// cutover.

export function DevModeBanner() {
  const { t } = useTranslation('common');
  return (
    <div className="dev-banner" role="status">
      <Warning size={16} weight="bold" aria-hidden />
      <span>{t('devBanner.message')}</span>
    </div>
  );
}
